// Constantes do fluxo "Criar imóvel" — espelha createPostConstants.ts do front
// imudei, adaptado ao ciclo do Chatwoot (sem planos de publicação/billing).

export const DRAFT_KEY = 'lais_criar_imovel_draft_v1';

export const PROPERTY_TYPES = [
  {
    tipo: 'Apartamento',
    subtipos: ['Apartamento Padrão', 'Loft', 'Kitchenette/Conjugados'],
  },
  {
    tipo: 'Casa',
    subtipos: ['Casa Padrão', 'Casa de Condomínio', 'Casa de Vila'],
  },
  { tipo: 'Terreno', subtipos: ['Terreno Padrão', 'Loteamento/Condomínio'] },
  { tipo: 'Flat/Aparthotel', subtipos: ['Flat'] },
  { tipo: 'Rural', subtipos: ['Chácara', 'Sítio', 'Fazenda', 'Haras'] },
  {
    tipo: 'Comercial/Industrial',
    subtipos: [
      'Conjunto Comercial/Sala',
      'Galpão/Depósito/Armazém',
      'Loja/Salão',
      'Casa Comercial',
      'Prédio Inteiro',
      'Studio',
      'Hotel',
      'Box/Garagem',
      'Indústria',
    ],
  },
];

export const CATEGORIES = [
  'Padrão',
  'Sobrado/Duplex',
  'Sobrado/Triplex',
  'Térrea',
  'Cobertura',
  'Cobertura Duplex',
  'Cobertura Triplex',
  'Duplex',
  'Triplex',
];

export const TRANSACTION_TYPES = ['Venda', 'Aluguel', 'Venda e Aluguel'];

export const FEATURES_LIST = [
  { key: 'arCondicionado', label: 'Ar Condicionado' },
  { key: 'churrasqueira', label: 'Churrasqueira' },
  { key: 'piscina', label: 'Piscina' },
  { key: 'jardim', label: 'Jardim' },
  { key: 'quintal', label: 'Quintal' },
  { key: 'lareira', label: 'Lareira' },
  { key: 'hidromassagem', label: 'Hidromassagem' },
  { key: 'sauna', label: 'Sauna' },
  { key: 'terraco', label: 'Varanda/Terraço' },
  { key: 'escritorio', label: 'Escritório' },
  { key: 'closet', label: 'Closet' },
  { key: 'areaServico', label: 'Área de serviço' },
  { key: 'mobiliado', label: 'Mobiliado' },
  { key: 'armarioEmbutido', label: 'Armário embutido' },
  { key: 'elevador', label: 'Elevador' },
  { key: 'seguranca', label: 'Segurança 24h' },
  { key: 'playground', label: 'Playground' },
  { key: 'academia', label: 'Academia' },
  { key: 'salaoFestas', label: 'Salão de festas' },
];

export const GUARANTEES = [
  { key: 'fiador', label: 'Fiador' },
  { key: 'seguroFianca', label: 'Seguro Fiança' },
  { key: 'depositoSeguranca', label: 'Depósito' },
  { key: 'tituloCapitalizacao', label: 'Capitalização' },
];

export const COMPLETION_HANDOFF_CHECKLIST = Object.freeze([
  {
    id: 'publicabilidade',
    label: 'Checklist de completude',
    owner: 'ImovelShow',
    routeName: 'imovel_show',
    section: 'resumo',
  },
  {
    id: 'estimativa_qpreco',
    label: 'Estimativa QPreço',
    owner: 'ImovelForm',
    routeName: 'imovel_edit',
    section: 'imovel-price-estimate',
  },
  {
    id: 'tax_fee_governance',
    label: 'Taxas e IPTU',
    owner: 'ImovelForm',
    routeName: 'imovel_edit',
    section: 'imovel-tax-fee-governance',
  },
  {
    id: 'entry_access_keys',
    label: 'Acessos e chaves',
    owner: 'ImovelForm',
    routeName: 'imovel_edit',
    section: 'imovel-key-access',
  },
]);

// Estado base do fluxo (espelha baseState do useCreatePostState.ts).
export const buildBaseState = () => ({
  selectedImages: [],
  titulo: '',
  descricao: '',
  tipoImovel: '',
  subTipoImovel: '',
  categoriaImovel: 'Padrão',
  transactionType: 'Venda',
  precoVenda: '',
  precoAluguel: '',
  cep: '',
  estado: '',
  cidade: '',
  bairro: '',
  endereco: '',
  numero: '',
  complemento: '',
  zona: '',
  areaUtil: '',
  areaTotal: '',
  qtdDormitorios: '',
  qtdBanheiros: '',
  qtdSuites: '',
  qtdVagas: '',
  iptu: '',
  valorCondominio: '',
  anoConstrucao: '',
  videoUrl: '',
  tourVirtualUrl: '',
  latitude: '',
  longitude: '',
  features: {},
  guarantees: {},
});

// Mapeia o transactionType (label pt-BR) para finalidade da coluna real.
export const mapFinalidade = value => {
  if (value === 'Aluguel') return 'aluguel';
  return 'venda';
};
